



































/* eslint-disable sort-imports */ // <- need to keep this specific order
import { ValidationProvider } from "vee-validate";
import Cleave from "cleave.js";
import "cleave.js/dist/addons/cleave-phone.us";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "AppInput",
  components: {
    ValidationProvider
  }
})
export default class AppInput extends Vue {
  // ===== Props ===== //
  @Prop(String || null) private readonly type?: string;
  @Prop([String, Object, Number, Array]) private readonly value?: string | number | object | [];
  @Prop(String) private readonly appendIcon!: string;
  @Prop(Boolean) private readonly clearable!: boolean;
  @Prop(Boolean) private readonly hideDetails!: boolean;
  @Prop(String) private readonly hint?: string;
  @Prop([String, Number]) private readonly counter?: string | number;
  @Prop({ default: "aggressive" }) private readonly mode?: string;
  @Prop({ default: false }) private readonly outlined?: boolean;
  @Prop({ default: false }) private readonly persistentHint?: boolean;
  @Prop(String) private readonly prependIcon?: string;
  @Prop({ default: "required" }) private readonly rules?: string;
  @Prop({ default: false }) private readonly useValidation?: boolean;
  // ===== Data ===== //
  private fill = true;
  private innerValue: unknown | null = null;
  private outline = false;
  // ===== Methods ===== //
  @Watch("innerValue")
  private emitNewValue<T>(newVal: T) {
    this.$emit("input", newVal);
  }
  @Watch("value")
  private setNewValue<T>(newVal: T) {
    this.innerValue = newVal;
  }
  // ===== Computed ===== //
  get delimiter(): string {
    return this.type === "phone" ? "-" : "";
  }
  get froalaConfig() {
    const config = {
      ...this.$store.state.app.froalaConfig,
      theme: this.$vuetify.theme.dark ? "dark" : null,
      requestHeaders: {
        Authorization: this.$store.state.auth.access_token
      }
    };
    return config;
  }
  // ===== Lifecycle Hooks ===== //
  private mounted(): void {
    this.innerValue = this.value;
  }
}
